// assets/agegate-translations.js
(function () {
  const TRANSLATIONS = {
    es: {
      "Welcome": "Bienvenido",
      "You must be of legal drinking age to enter this site.": "Debes tener la edad legal para consumir alcohol para entrar en este sitio.",
      "Enter site": "Entrar",
      "Leave": "Salir",
      "By entering, you confirm you are of legal drinking age and accept our Terms of Use.": "Al entrar, confirmas que tienes la edad legal para consumir alcohol y aceptas nuestros Términos de uso.",
      // variantes posibles
      "By entering, you confirm you are of legal drinking age and accept our Terms Of Use.": "Al entrar, confirmas que tienes la edad legal para consumir alcohol y aceptas nuestros Términos de uso.",
      "Access restricted.": "Acceso restringido."
    },

    de: {
      "Welcome": "Willkommen",
      "You must be of legal drinking age to enter this site.": "Du musst das gesetzliche Mindestalter für den Alkoholkonsum erreicht haben, um diese Seite zu betreten.",
      "Enter site": "Seite betreten",
      "Leave": "Verlassen",
      "By entering, you confirm you are of legal drinking age and accept our Terms of Use.": "Mit dem Betreten bestätigst du, dass du das gesetzliche Mindestalter erreicht hast und unsere Nutzungsbedingungen akzeptierst.",
      "By entering, you confirm you are of legal drinking age and accept our Terms Of Use.": "Mit dem Betreten bestätigst du, dass du das gesetzliche Mindestalter erreicht hast und unsere Nutzungsbedingungen akzeptierst.",
      "Access restricted.": "Zugang verweigert."
    }
  };

  const locale =
    (window.Shopify && Shopify.locale) ||
    document.documentElement.getAttribute("lang") ||
    "en";
  const lang = String(locale).split("-")[0].toLowerCase();

  const map = TRANSLATIONS[lang];
  if (!map) return;

  const replacer = (text) => {
    const trimmed = text.trim();
    return map.hasOwnProperty(trimmed) ? map[trimmed] : text;
  };

  const translate = () => {
    // nodos de texto
    const walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      null
    );

    let node;
    while ((node = walker.nextNode())) {
      if (!node.nodeValue || !node.nodeValue.trim()) continue;
      node.nodeValue = replacer(node.nodeValue);
    }

    // por si los botones quedan fuera del walker (shadow/innerText raro)
    document.querySelectorAll("button, a, span, div").forEach((el) => {
      const text = el.textContent;
      const trimmed = text.trim();
      if (!trimmed) return;
      if (map.hasOwnProperty(trimmed)) {
        el.textContent = text.replace(trimmed, map[trimmed]);
      }
    });
  };

  translate();

  // si el widget aparece después (mutaciones), re-traducir
  const observer = new MutationObserver(() => translate());
  observer.observe(document.body, { childList: true, subtree: true });
})();